import React from 'react';
import Dropdown from '../../Components/Dropdown/Dropdown';
import { Button, Input, Textarea } from '../../Components/StyledComponents';
import { onlyNum } from '../../Utils/functions';
import './CouponCreate.scss';

const CouponCreate = ({ createCoupon }) => {
    const [ name, setName ] = React.useState('')//쿠폰이름
    const [ type, setType ] = React.useState('상품증정')//쿠폰 타입
    const [ desc, setDesc ] = React.useState('')//쿠폰 설명
    const [ expiry, setExpiry ] = React.useState('30')//유효기간

    //쿠폰 생성
    const create = () => {
        createCoupon(name,desc,type,expiry)
    }
    
    return (
        <div className='coupon-create'>
            <div className='row between'>
                <p className='input-label'>쿠폰명</p>
                <Input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder='쿠폰명을 입력해주세요.'
                    style={{ width : 347 }}
                />
            </div>
            <div className='row between'>
                <p className='input-label'>쿠폰타입</p>
                <Dropdown
                    key={'coupon-type'}
                    options={[
                        { key : '상품증정', value : '상품증정'},
                        { key : '%할인', value : '% 할인'},
                        { key : '원할인', value : '원 할인'},
                        { key : '1+1', value : '1+1'},
                    ]}
                    width={347}
                    value={type}
                    onItemClick={(val) => setType(val)}
                />
            </div>
            <div className='row between' style={{ alignItems : 'flex-start'}}>
                <p className='input-label'>쿠폰설명</p>
                <Textarea
                    value={desc}
                    onChange={(e) => setDesc(e.target.value)}
                    placeholder='쿠폰 설명을 입력해주세요.'
                    style={{ width : 347, height : 173 }}
                />
            </div>

            <div className='row between' style={{ marginBottom : 8 }}>
                <p className='input-label'>유효기간</p>
                <label htmlFor="pointEnd" data-domain="일">
                    <Input
                        value={expiry}
                        onChange={(e) => setExpiry(onlyNum(e.target.value))}
                        placeholder='0'
                        style={{ width : 347 }}
                    />
                </label>
            </div>
            <p className='warn-text'>*발행 후 사용 기간 (일 단위)</p>
            <div className='btn-row'>
                <Button
                    variant="main"
                    fontSize={16}
                    style={{ width : 118, alignSelf: 'flex-end' }}
                    disabled={(name.trim() === '' || desc.trim() ==='' || expiry === '' )}
                    onClick={() => create()}
                >
                    발행하기
                </Button>
            </div>
        </div>
    )
}

export default CouponCreate;